export enum Tipo {
  SUBPASTA = 'SUBPASTA',
  DOCUMENTO = 'DOCUMENTO',
}
